import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import ProductImage from '../../ProductImage';
import { useProductDescriptionStyles } from './styles';
import { priceFormatter } from '../../../../../../helpers/ProductHelper';
import { formatDateWithoutTime } from '../../../../../../helpers/DateFormatter';

const ProductDescription = ({ ...props }) => {
  const { image, name, orderId, quantity, totalPrice, purchaseDate } = props;
  const classes = useProductDescriptionStyles();
  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      className={classes.container}
    >
      <div className={classes.divider} />
      <ProductImage src={image} purchaseState="normal" mobile />
      <Box
        display="flex"
        flexDirection="column"
        marginLeft="41px"
        className={classes.textContainer}
        width="100%"
      >
        <Typography className={classes.title}>{name}</Typography>
        <Box display="flex">
          <Box display="flex" flexDirection="column" marginRight="100px">
            <Typography className={classes.subtypo}>
              <strong>Nºde compra:</strong>&nbsp;
              {orderId}
            </Typography>
            <Typography className={classes.subtypo}>
              <strong>Cantidad:</strong>&nbsp;
              {quantity}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography className={classes.subtypo}>
              <strong>Total de la compra:</strong>&nbsp;
              {priceFormatter(totalPrice)}
            </Typography>
            <Typography className={classes.subtypo}>
              <strong>Fecha de compra:</strong>&nbsp;
              {formatDateWithoutTime(purchaseDate)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

ProductDescription.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  orderId: PropTypes.number,
  quantity: PropTypes.number,
  totalPrice: PropTypes.number,
  purchaseDate: PropTypes.string,
};

export default ProductDescription;
